import { apiFetcher } from '~/apis/api-fetcher';

import { ProductDescriptionResponse } from './models';

export type ProductDescriptionParams = {
  pid: number;
};

/** 메루카리 상품 설명 조회 */
export const getProductDescription = ({ pid }: ProductDescriptionParams, requestInit?: RequestInit) =>
  apiFetcher.get<ProductDescriptionResponse>(`/api/pms/v1/mercari/products/${pid}/description`, undefined, requestInit);
